import React, { Component } from "react";
import "./style.css";

export default class ListWithCheckbox extends Component {
  state = {
    checked: this.props.checked
  };

  componentWillReceiveProps = nextProps => {
    this.setState({ checked: nextProps.checked });
  };

  handleClick = () => {
    const { onChecked = function() {}, id = 1 } = this.props;
    const { checked } = this.state;

    onChecked(id);
    this.setState({ checked: !checked });
  };

  render() {
    const {
      icon,
      text,
      mainContainerClasses,
      ListCheckboxContainerClasses,
      ListCheckboxContainerStyles,
      checkBoxContainerClasses,
      checkBoxContainerStyles,
      listContainerClasses,
      listContainerStyles
    } = this.props;
    const { checked } = this.state;

    return (
      <div className={mainContainerClasses}>
        <div
          className={`list-checkbox-container my-3 ${ListCheckboxContainerClasses}`}
          style={ListCheckboxContainerStyles}
          onClick={this.handleClick}
        >
          <div
            className={`checkbox-container ${checked &&
              "checkbox-container-checked"} ${checkBoxContainerClasses}`}
            style={checkBoxContainerStyles}
          >
            {checked && <img src={icon} alt="check" />}
          </div>
          <ul
            className={`pl-3 ${listContainerClasses}`}
            style={listContainerStyles}
          >
            <li className="pl-3">{text}</li>
          </ul>
        </div>
      </div>
    );
  }
}
